import { WorkflowManifestFragment } from 'generated/resources/graphql'

import { VariablesConfig } from 'modules/workflows/components/Sidepanel/VariableSelectorTypes'
import { WorkflowsComparison } from 'modules/workflows/lib/types'

type WorkflowDataInput = WorkflowManifestFragment['workflowDataInputs'][number]

export const getSelectedVariableNames = (expressions: WorkflowsComparison[]): Set<string> =>
  new Set(expressions.map((c) => c.left.name).filter(Boolean))

export const filterStaticInputVariables = (
  workflowDataInputs: WorkflowDataInput[],
  variablesConfig: VariablesConfig,
  selectedVariableNames: Set<string>
) =>
  workflowDataInputs
    .filter((input) => {
      const config = variablesConfig && variablesConfig[input.name]
      if (!config) return false
      if (config.hidden) return selectedVariableNames.has(input.name)
      return true
    })
    .map((input) => {
      const config = variablesConfig[input.name]
      return {
        label: config?.label ?? input.name,
        value: input.name,
        source: 'input' as const,
        icon: config?.icon,
        hidden: config?.hidden,
      }
    })
